
import Helpers from "commons/helpers";
import Constants from "constants/index";
import MedkitService from "./medkit.service";
import { IRecordClassifyByHospitalStatistics, IRecordDepartmentStatistics, IRecordSynthetic, IResponseGetPaged } from "commons/interfaces";

class StatisticsService extends MedkitService {

    public getStatistics = async (data: {
        status?: string;
        endTime?: string | number;
        startTime?: string | number;
        onlyOpenedReport?: number;
    }): Promise<{
        reportType: any
        reportStatus: any
        incidentObject: any
    }> => {
        const query = Helpers.handleFormatParams(data);
        const result = await this.api.get({
            path: Constants.ApiPath.STATISTICS.GET_STATISTICS + `${query ? "?" : ""}${query}`
        });
        return result.data.result;
    };

    public getDepartmentStatistics = async (data: {
        date?: any;
        groupIds?: string[];
        pageSize?: number;
        pageNumber?: number;
    }): Promise<IResponseGetPaged<IRecordDepartmentStatistics>> => {
        const query = Helpers.handleFormatParams(data);
        const result = await this.api.get({
            path: Constants.ApiPath.STATISTICS.GET_DEPARTMENT_STATISTICS + `${query ? "?" : ""}${query}`
        });
        return result.data.result;
    };

    public getClassifyByHospitalStatistics = async (data: {
        pageSize?: number;
        pageNumber?: number;
    }): Promise<IResponseGetPaged<IRecordClassifyByHospitalStatistics>> => {
        const query = Helpers.handleFormatParams(data);
        const result = await this.api.get({
            path: Constants.ApiPath.STATISTICS.GET_CLASSIFY_BY_HOSPITAL_STATISTICS + `${query ? "?" : ""}${query}`
        });
        return result.data.result;
    };

    public getStatisticsByYear = async (data: {
        year: number;
        groupId?: string;
    }): Promise<any> => {
        const query = Helpers.handleFormatParams(data);
        const result = await this.api.get({
            path: Constants.ApiPath.STATISTICS.GET_STATISTICS_BY_YEAR + `${query ? "?" : ""}${query}`
        });
        return result.data.result;
    };

    public getSyntheticList = async (data: {
        date: number | string;
        projectIds?: string[];
        organizationIds: string[];
    }): Promise<IRecordSynthetic[]> => {
        const query = Helpers.handleFormatParams(data);
        const result = await this.api.get({
            path: Constants.ApiPath.STATISTICS.GET_SYNTHETIC_LIST + `${query ? "?" : ""}${query}`
        });
        return result.data.result;
    };

    public getFishBone = async (data: {
        reason: string;
    }): Promise<IRecordSynthetic[]> => {
        const query = Helpers.handleFormatParams(data);
        const result = await this.api.get({
            path: Constants.ApiPath.STATISTICS.GET_FISHBONE + `${query ? "?" : ""}${query}`
        });
        return result.data.result;
    };

    public getFishBoneSolution = async (data: {
        fishboneFullContent: string;
        fishboneChoosedContent: string;
        reason: string
    }): Promise<IRecordSynthetic[]> => {
        const result = await this.api.post({
            path: Constants.ApiPath.STATISTICS.GET_FISHBONE_SOLUTION,
            data
        });
        return result.data.result;
    };

};

export default StatisticsService;
